import React from 'react';
import axios from 'axios';
import api from '../../config/api';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SubHeader from '../../components/Layout/SubHeader';
import { withRouter } from '../../config/withRouter';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';

class PromotionScreen extends React.Component {
    constructor(props) {
        super(props);
        const { id } = this.props.params;
        var pageData = (this.props && this.props.location && this.props.location.search) ? this.props.location.search : '';
        var current_page = (pageData && pageData.split("page=") && pageData.split("page=")[1]) ? pageData.split("page=")[1] : 1;
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            id: id,
            promotionArray: [],
            showPromotion: false,
            next_page_url: null,
            current_page: current_page,
        }
    }

    async componentDidMount() {
        let self = this;
        const user_token = await localStorage.getItem('user_token');
        self.setState({ access_token: user_token });

        // this.getNewProductData();
        self.getFirstProductData(api.PromotionData + "?page=" + self.state.current_page);
    }

    getFirstProductData(API) {
        const self = this;
        if (!API) {
            return false;
        }        
        axios({
            method: 'get', url: API,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            const items = ress.data.message.data;
            const movedItem = items.find((item) => item.id == self.state.id);            
            self.setState({ promotionArray: [movedItem] });
            setTimeout(() => {
                self.getNewProductData();
            });
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
        });
    }

    getNewProductData() {
        const self = this;
        var API = api.PromotionData + "?lang=" + self.state.lang;
        axios({
            method: 'get', url: API,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({
                showPromotion: true,
                isLoading: false,
                promotionArray: [...self.state.promotionArray, ...ress.data.message.data],
                next_page_url: ress.data.message.next_page_url
            });
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ ProgressBar: false });
            self.setState({ 'isLoading': false });
        });
    }

    getPromotionDataNext(API) {
        const self = this;
        if (!API) {
            return false;
        }
        axios({
            method: 'GET',
            url: API,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ isLoading: false })
            if (ress.data.error == 200) {
                self.setState({
                    promotionArray: [...self.state.promotionArray, ...ress.data.message.data],
                    next_page_url: ress.data.message.next_page_url,
                });
            }
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
        });
    }

    render() {
        const promotionArraySetting = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 480 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 480, min: 0 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            }
        };

        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <div className='PromotionScreen'>
                    <SubHeader data={{ title: strings["Promotion"] }} />


                    <main className="promo-container">
                        {this.state.showPromotion ?
                            <Carousel
                                centerMode={false}
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                responsive={promotionArraySetting}
                                containerClass="promotion-container"
                                infinite={false}
                                beforeChange={(nextSlide, { currentSlide, onMove }) => {
                                    if ((nextSlide + 1) === this.state.promotionArray.length) {
                                        
                                        this.getPromotionDataNext(this.state.next_page_url);
                                    }
                                }}
                            >
                                {this.state.promotionArray.map((item, i) =>
                                    <div key={"ITEM_001_" + i} className='main-block'>
                                        <div className="align-content">
                                            <img src={item.image_url} className="promo-image" alt='' />
                                        </div>
                                        <div className="align-content">
                                            <p className="promo-info">{item.title ?? ''}</p>
                                        </div>
                                    </div>
                                )}
                            </Carousel>
                            : null}
                    </main>
                </div>
            </>
        );
    }
}

export default withRouter(PromotionScreen);
